/* eslint-disable */
export const reactLocalStorageService = (window as any).getLocalStorageService();
